import { useEffect, useRef } from 'react';
import { env } from 'env/client.mjs';
import { useRouter } from 'next/router';
import { useSession } from 'next-auth/react';
import { Userpilot } from 'userpilot';

const isUserpilotEnabled =
  (env.NEXT_PUBLIC_BP_ENV === 'production' ||
    env.NEXT_PUBLIC_BP_ENV === 'sandbox') &&
  !!env.NEXT_PUBLIC_USERPILOT_TOKEN;

export const UserpilotProvider = () => {
  const router = useRouter();
  const { data: session, status } = useSession();
  const userpilotIdentified = useRef(false);

  useEffect(() => {
    if (!isUserpilotEnabled) {
      return;
    }

    Userpilot.initialize(env.NEXT_PUBLIC_USERPILOT_TOKEN!);
  }, []);

  useEffect(() => {
    if (
      !isUserpilotEnabled ||
      status !== 'authenticated' ||
      !session?.user?.id ||
      userpilotIdentified.current
    ) {
      return;
    }

    Userpilot.identify(session.user.id, {
      name: session.user.name ?? undefined,
      email: session.user.email ?? undefined,
      userRole: session.user.role,
      company: {
        id: session.user.organizationId,
        name: session.user.organization?.name,
        orgType: session.user.organization?.type,
      },
    });
    userpilotIdentified.current = true;
  }, [session, status]);

  useEffect(() => {
    if (!isUserpilotEnabled) {
      return;
    }

    const handleRouteChange = () => {
      Userpilot.reload();
    };

    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);

  return null;
};
